module.exports = __webpack_public_path__ + "static/media/_logo.055c5a90.svg";